export default {
      id: "target-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#target",
      toString: function () {
        return this.url;
      }
    }